// extracted by mini-css-extract-plugin
export default {"thumbFrame":"MediaBlockThumb_thumbFrame__YAEca","thumbTall":"MediaBlockThumb_thumbTall__kpgGz","thumbImage":"MediaBlockThumb_thumbImage__ARAwH"};